// lib/constants.js
export const FORM_FIELDS_CONFIG = {
  // Personal info
  name: {
    type: "text",
    label: "What's Your Name?",
    placeholder: "Please enter your firstname",
    required: true
  },
  email: {
    type: "email",
    label: "Email Address",
    placeholder: "Please enter your email",
    required: true
  },
  message: {
    type: "textarea",
    label: "Message",
    placeholder: "Message for me",
    rows: 4,
    required: true
  },
  
  // Service details
  date: {
    type: "date",
    label: "Date of Service",
    required: true
  },
  time: {
    type: "time",
    label: "Time of Service",
    required: true
  },
  problem: {
    type: "select",
    label: "What was the problem?",
    required: true
  },
  waitTime: {
    type: "select",
    label: "How long did you have to wait before the patrol driver arrived?",
    required: true
  },
  howDriverKnew: {
    type: "select",
    label: "How did the patrol driver know you needed assistance?",
    required: true
  },
  vehicleLocation: {
    type: "select",
    label: "Where was your vehicle located?",
    required: true
  },
  serviceTime: {
    type: "select",
    label: "How long did the patrol driver spend helping to resolve the problem?",
    required: true
  },
  driverName: {
    type: "text",
    label: "What was the patrol driver's name?",
    placeholder: "Driver's Name",
    required: true
  },
  
  // Driver rating
  safetyRating: {
    type: "select",
    label: "Did the patrol driver show concern for your safety, and act accordingly?",
    required: true
  },
  professionalismRating: {
    type: "select",
    label: "Was the patrol driver professional and courteous?",
    required: true
  },
  overallRating: {
    type: "select",
    label: "How would you rate the service?",
    required: true
  },
  surveyCode: {
    type: "text",
    label: "Did your driver provide a survey code? (optional)",
    placeholder: "ABCD5678",
    required: false
  }
};

export const INITIAL_FORM_DATA = Object.keys(FORM_FIELDS_CONFIG).reduce((acc, key) => {
  acc[key] = "";
  return acc;
}, {});

export const SELECT_OPTIONS = {
  problem: [
    { value: "", label: "Please select..." },
    { value: "overheating", label: "Overheating" },
    { value: "mechanical", label: "Mechanical" },
    { value: "out-of-fuel", label: "Out of Fuel" },
    { value: "dead-battery", label: "Dead Battery" },
    { value: "flat-tire", label: "Flat Tire" },
    { value: "needed-tow", label: "Needed Tow" },
    { value: "accident", label: "Accident" },
    { value: "other", label: "Other" }
  ],
  
  waitTime: [
    { value: "", label: "Please select..." },
    { value: "0-10", label: "0-10 minutes" },
    { value: "11-20", label: "11-20 minutes" },
    { value: "21-30", label: "21-30 minutes" },
    { value: "30+", label: "30+ minutes" }
  ],
  
  howDriverKnew: [
    { value: "", label: "Please select..." },
    { value: "cellular-phone", label: "Cellular Phone" },
    { value: "police", label: "Police" },
    { value: "driver-saw-me", label: "Driver Saw me" },
    { value: "dont-know", label: "I Don't Know" },
    { value: "other", label: "Other" }
  ],
  
  vehicleLocation: [
    { value: "", label: "Please select..." },
    { value: "travel-lane", label: "In a travel lane" },
    { value: "shoulder", label: "On the shoulder" },
    { value: "off-road-grass", label: "Off the road and on the grass" }
  ],
  
  serviceTime: [
    { value: "", label: "Please select..." },
    { value: "0-10", label: "0-10 minutes" },
    { value: "11-20", label: "11-20 minutes" },
    { value: "21-30", label: "21-30 minutes" },
    { value: "30+", label: "30+ minutes" }
  ],
  
  safetyConcern: [
    { value: "", label: "Please select..." },
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" }
  ],
  
  professional: [
    { value: "", label: "Please select..." },
    { value: "extremely", label: "Extremely" },
    { value: "very", label: "Very" },
    { value: "somewhat", label: "Somewhat" },
    { value: "not-at-all", label: "Not at all" },
    { value: "no-opinion", label: "No opinion" }
  ],
  
  rating: [
    { value: "", label: "Please select..." },
    { value: "5", label: "5 - Excellent" },
    { value: "4", label: "4 - Very Good" },
    { value: "3", label: "3 - Good" },
    { value: "2", label: "2 - Fair" },
    { value: "1", label: "1 - Poor" }
  ]
};

export const FIELD_OPTIONS_MAP = {
  problem: SELECT_OPTIONS.problem,
  waitTime: SELECT_OPTIONS.waitTime,
  howDriverKnew: SELECT_OPTIONS.howDriverKnew,
  vehicleLocation: SELECT_OPTIONS.vehicleLocation,
  serviceTime: SELECT_OPTIONS.serviceTime,
  safetyRating: SELECT_OPTIONS.safetyConcern,
  professionalismRating: SELECT_OPTIONS.professional,
  overallRating: SELECT_OPTIONS.rating
};

export const FORM_FIELDS_ORDER = [
  "name", 
  "email", 
  "message",
  "date",
  "time",
  "problem",
  "waitTime",
  "howDriverKnew",
  "vehicleLocation",
  "serviceTime",
  "driverName",
  "safetyRating",
  "professionalismRating",
  "overallRating",
  "surveyCode"
];

export const QUESTION_MAP = {
  name: "What's Your Name?",
  email: "Email Address",
  message: "Message",
  date: "Date of Service",
  time: "Time of Service",
  problem: "What was the problem?",
  waitTime: "How long did you have to wait before the patrol driver arrived?",
  howDriverKnew: "How did the patrol driver know you needed assistance?",
  vehicleLocation: "Where was your vehicle located?",
  serviceTime: "How long did the patrol driver spend helping to resolve the problem?",
  driverName: "What was the patrol driver's name?",
  safetyRating: "Did the patrol driver show concern for your safety, and act accordingly?",
  professionalismRating: "Was the patrol driver professional and courteous?",
  overallRating: "How would you rate the service?",
  surveyCode: "Did your driver provide a survey code? (optional)",
};